module.exports = __webpack_public_path__ + "img/prinsix-logo.05969285.png";